jQuery(function ($) {
    $('.faq-item').on('click', function () {
        const answer = $(this).find('.a-cont');
        answer.stop(true, true).slideToggle(300);
        $(this).toggleClass('active');
    });
});